export default __webpack_public_path__ + "static/media/404-error.563a0798.jpg";